import { getVersionAnchor } from "./getVersionAnchor";
export const scrollToRelease = (version) => (e) => {
    const anchor = getVersionAnchor(version);
    document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
    e.preventDefault();
    return false;
};
